module.exports = __webpack_public_path__ + "static/media/bgi_privacy_keeping@3x.daa585c5.png";